<template>
    <div class="input-item">
        <div class="top">
            <span class="required" v-if="required">*</span>
            <div class="title" v-html="title"></div>
        </div>
        <InputOption :isDetails="isDetails" v-model="input.value" v-bind="input.props"/>
    </div>
</template>
<script>
    import InputOption from './Private/InputOption.vue'
    export default {
        name: 'InputItem',
        props: {
            title:String,
            required:Boolean,
            input:Object,
            isDetails:{
                type:Boolean,
                default:false
            }
        },
        methods:{

        },
        components:{InputOption}
    }
</script>
<style lang="scss" scoped>
    .input-item{
        padding: 16px;
        .top{
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            .required{
                color: #F84025;
                margin-right: 6px;
            }
            .title{
                color: #26292F;
                font-size: 16px;
            }
        }
    }

</style>
